<template>
    <div class="feedbackboard-phonemic-vowel">
        <div class="feedbackboard-phonemic-vowel__feature-type">
            <span class="feedbackboard-phonemic-vowel__feature-label">DİLİN DEVİNİMİ</span>
            <div class="feedbackboard-phonemic-vowel__feature-options">
                <BtnOptionFeedback
                    :class="{ 'btn-option-feedback--skipped': feedbackBackness.answerValue === '' }"
                    :optionText="$t('vowel.backness.' + feedbackBackness.correctValue)" />
                <BtnOptionFeedback
                    v-if="feedbackBackness.correctValue !== feedbackBackness.answerValue
                        && feedbackBackness.answerValue !== ''"
                    class="btn-option-feedback--incorrect"
                    :optionText="$t('vowel.backness.' + feedbackBackness.answerValue)" />
            </div>
        </div>

        <div class="feedbackboard-phonemic-vowel__feature-type">
            <span class="feedbackboard-phonemic-vowel__feature-label">ÇENE AÇISI</span>
            <div class="feedbackboard-phonemic-vowel__feature-options">
                <BtnOptionFeedback
                    :class="{ 'btn-option-feedback--skipped': feedbackHeight.answerValue === '' }"
                    :optionText="$t('vowel.height.' + feedbackHeight.correctValue)" />
                <BtnOptionFeedback
                    v-if="feedbackHeight.correctValue !== feedbackHeight.answerValue
                        && feedbackHeight.answerValue !== ''"
                    class="btn-option-feedback--incorrect"
                    :optionText="$t('vowel.height.' + feedbackHeight.answerValue)" />
            </div>
        </div>

        <div class="feedbackboard-phonemic-vowel__feature-type">
            <span class="feedbackboard-phonemic-vowel__feature-label">DUDAK DURUMU</span>
            <div class="feedbackboard-phonemic-vowel__feature-options">
                <BtnOptionFeedback
                    :class="{ 'btn-option-feedback--skipped': feedbackRoundedness.answerValue === '' }"
                    :optionText="$t('vowel.roundedness.' + feedbackRoundedness.correctValue)" />
                <BtnOptionFeedback
                    v-if="feedbackRoundedness.correctValue !== feedbackRoundedness.answerValue
                        && feedbackRoundedness.answerValue !== ''"
                    class="btn-option-feedback--incorrect"
                    :optionText="$t('vowel.roundedness.' + feedbackRoundedness.answerValue)" />
            </div>
        </div>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    import BtnOptionFeedback from '@/components/BtnOptionFeedback.vue';


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        components: {
            BtnOptionFeedback,
        },

        computed: {
            feedbackBackness(){
                return this.$store.state.feedbackData.backness;
            },

            feedbackHeight(){
                return this.$store.state.feedbackData.height;
            },

            feedbackRoundedness(){
                return this.$store.state.feedbackData.roundedness;
            }
        }
    };
</script>

<style scoped src="@/css/components/feedbackboard-phonemic-vowel.css"></style>